import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import SortRoundedIcon from "@mui/icons-material/SortRounded";
import React from "react";
import styled from "styled-components";
import { SortModes } from "../../constants/types";
import { useLocationAccessDenied, useSortMode } from "../../services/app-state";
import { buttonResetStyles, useSuburbName } from "../../utils";
import { getSuburbSelectUrl } from "../../utils/basic-only";
import { colors } from "../../utils/colors";

interface Props {
    appearance?: "light" | "dark";
}

export const Wrapper = styled.button<{ color: string, bgcolor: string }>`
    ${buttonResetStyles};
    display: inline-flex;
    gap: 4px;
    width: auto;
    align-items: center;
    color: ${({ color }) => color};
    font-weight: 500;
    padding: 8px 15px;
    background: ${({ bgcolor }) => bgcolor};
    border-radius: 9999em;
    border: 1px solid ${({ color }) => color};

    &.active{
        background: ${({ color }) => color};
        color: ${({ bgcolor }) => bgcolor};
    }

    @media only screen and (max-width: 640px) {
        min-width: fit-content;
        text-align: center;
    }
`;

export const SortDistanceButton: React.FC<Props> = ({ appearance = "dark" }) => {
    const suburbName = useSuburbName();
    const [sortMode, { setSortMode }] = useSortMode();
    const [locationAccessDenied] = useLocationAccessDenied();
    const color = appearance == "dark" ? colors.brandMid : colors.white;
    const bgcolor = appearance == "dark" ? '#eff3fe' : '#5970f5';

    if (suburbName == null) {
        return (
            <Wrapper
                color={color}
                bgcolor={bgcolor}
                onClick={() => {
                    window.location.href = getSuburbSelectUrl();
                }}
            >
                <LocationOnRoundedIcon />
                Set suburb to show distance
            </Wrapper>
        );
    }

    if (locationAccessDenied) {
        return null;
    }

    return (
        <Wrapper
            color={color}
            bgcolor={bgcolor}
            onClick={() => {
                setSortMode(
                    sortMode === SortModes.DistanceFromSuburb
                        ? SortModes.DistanceFromUser
                        : SortModes.DistanceFromSuburb,
                );
            }}
        >
            <SortRoundedIcon />
            {sortMode === SortModes.DistanceFromSuburb
                ? "Show distance from me"
                : `Show distance from ${suburbName}`}
        </Wrapper>
    );
};
